import React from 'react';
import './TrackingSection.css';

const TrackingSection: React.FC = () => {
  return (
    <section id="tracking" className="tracking-section">
      <div className="tracking-container">
        <div className="tracking-header">
          <h2 className="tracking-title">Track every call in real-time.</h2>
          <p className="tracking-description">
            Search through your call history instantly with powerful filtering and real-time updates. 
            Find any call, agent, or conversation in seconds with our lightning-fast search engine.
          </p>
        </div>
        
        <div className="tracking-content">
          <div className="tracking-visual">
            <div className="laptop-mockup">
              <div className="laptop-screen">
                <div className="search-interface">
                  <div className="search-header">
                    <div className="search-bar">
                      <div className="search-icon">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                          <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" fill="currentColor"/>
                        </svg>
                      </div>
                      <input 
                        type="text" 
                        placeholder="Search calls, agents, or conversations..." 
                        className="search-input"
                        readOnly
                      />
                      <div className="search-shortcut">
                        <span className="shortcut-key">⌘</span>
                        <span className="shortcut-key">K</span>
                      </div>
                    </div>
                  </div>
                  
                  <div className="search-results">
                    <div className="result-item">
                      <div className="result-icon">📞</div>
                      <div className="result-content">
                        <div className="result-title">Call #12345 - Customer Support</div>
                        <div className="result-meta">AI Agent 1 • 2:34 • Positive sentiment</div>
                      </div>
                      <div className="result-status success">Completed</div>
                    </div>
                    
                    <div className="result-item">
                      <div className="result-icon">🎯</div>
                      <div className="result-content">
                        <div className="result-title">Call #12346 - Sales Inquiry</div>
                        <div className="result-meta">AI Agent 2 • 1:45 • Neutral sentiment</div>
                      </div>
                      <div className="result-status success">Completed</div>
                    </div>
                    
                    <div className="result-item">
                      <div className="result-icon">⚠️</div>
                      <div className="result-content">
                        <div className="result-title">Call #12347 - Technical Issue</div>
                        <div className="result-meta">AI Agent 1 • 0:12 • Failed</div>
                      </div>
                      <div className="result-status error">Failed</div>
                    </div>
                    
                    <div className="result-item">
                      <div className="result-icon">📞</div>
                      <div className="result-content">
                        <div className="result-title">Call #12348 - Billing Question</div>
                        <div className="result-meta">AI Agent 3 • 3:21 • Positive sentiment</div>
                      </div>
                      <div className="result-status success">Completed</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <div className="tracking-info">
            <div className="info-section">
              <h3 className="info-title">Instant search with Cmd+K</h3>
              <p className="info-description">
                Press Cmd+K (or Ctrl+K) from anywhere in the application to instantly 
                search through your entire call history and agent database.
              </p>
            </div>
            
            <div className="search-features">
              <div className="feature-item">
                <div className="feature-icon">🔍</div>
                <div className="feature-text">Real-time search</div>
              </div>
              <div className="feature-item">
                <div className="feature-icon">📊</div>
                <div className="feature-text">Advanced filtering</div>
              </div>
              <div className="feature-item">
                <div className="feature-icon">⚡</div>
                <div className="feature-text">Instant results</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrackingSection;
